export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';

export function setTransactionData(transactionData) {
  return {
    type: SET_TRANSACTION_DATA,
    data: transactionData
  };
}

const initialState = {
  localTransactionId: '',
  transactionId: '',
  contextID: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_TRANSACTION_DATA:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
